<div class="font-bold mb-3" i18n>Do you want to configure the Admin Agent for HTTP-OTA?</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <tr>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="configureAdminAgent"
          inputId="configureAdminAgent#1"
          value="1"
          [(ngModel)]="profileValues.adminAgent.configureAdminAgent"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="configureAdminAgent#1" i18n>Yes</label>
      </td>
      <td>
        <p-radioButton
          (onClick)="handleFormEvents()"
          name="configureAdminAgent"
          inputId="configureAdminAgent#0"
          value="0"
          [(ngModel)]="profileValues.adminAgent.configureAdminAgent"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 mr-6 label-clickable" for="configureAdminAgent#0" i18n>No</label>
      </td>
    </tr>
  </table>
</div>
